import usePing from "../websocket/usePing";
import { useEffect, useRef, useState } from "react";
import useKlines from "../websocket/useKlines";

const socketType = process.env.REACT_APP_SOCKET_TYPE;

const useKline = (cryptoPair, klineInterval, page) => {
  const { liveResult: webSocketResult, shouldUseWebSocket } = useKlines(
    cryptoPair?.toUpperCase(),
    klineInterval.websocket,
    page
  );

  const { shouldUseWebSocket: pingPong } = usePing();
  const [result, setResult] = useState([[0]]);

  let interval = useRef(null);

  useEffect(() => {
    if (pingPong && shouldUseWebSocket) {
      clearInterval(interval.current);

      webSocketResult[webSocketResult?.length - 1] !== undefined &&
        result[result?.length - 1][0] !==
          webSocketResult[webSocketResult?.length - 1][0] &&
        setResult((prev) => webSocketResult);
    } else {
    }
    return () => pingPong && shouldUseWebSocket && clearInterval(interval.current);
  }, [pingPong, shouldUseWebSocket, webSocketResult, klineInterval]);

  //اطلاعات کل کندل های چارت اینجاست
  const objectedData = [];

  if (socketType === "iran") {
    const res = JSON.parse(result);

    if (!res.error && res.result) {
      res?.result.map((item) =>
        objectedData.push({
          id: Number(item[0]),
          open: Number(item[1]),
          close: Number(item[2]),
          high: Number(item[3]),
          low: Number(item[4]),
          vol: Number(item[5]),
        })
      );
    }
  } else {
    result.map((item) =>
      objectedData.push({
        id: Number(item[0]),
        open: Number(item[1]),
        close: Number(item[2]),
        high: Number(item[3]),
        low: Number(item[4]),
        vol: Number(item[5]),
      })
    );
  }

  return objectedData;
};
export default useKline;
